<template>
    <div class="uk-width-2-5@xl">
        <div class="uk-grid">
            <div class="uk-width-2-3">
                <label for="req_number" class="uk-form-label">Requisition Number</label>
                <div class="uk-form-controls">
                    <input id="req_number" type="text" name="number" class="uk-input" v-model="reqNumber" placeholder="Leave blank to generate" />
                </div>
            </div>
            <div class="uk-width-1-3" style="padding-top: 24px;">
                <button ref="check_btn" type="button" class="uk-button" style="padding: 0 1em" @click="checkNumber" ><i class="fas fa-check-double"></i> Confirm</button>
            </div>
        </div>
        <div class="uk-grid">
            <div class="uk-width-2-3">
                <label for="req_number" class="uk-form-label">Requisition Status</label>
                <div v-if="canEditStatus" class="uk-form-controls">
                    <select class="uk-select" name="status" v-model="status">
                        <option value="" >-- SELECT Status --</option>
                        <option v-for="val in statusOptions" :value="val.value" >{{val.name}}</option>
                    </select>
                </div>
                <div v-if="!canEditStatus">
                    <input type="hidden" name="status" v-model="status">
                    {{ statusName }}
                </div>
            </div>
        </div>
        <div class="uk-grid">
            <div class="uk-width-2-3">
                <label class="uk-form-label">Requesting Manager</label>
                <select class="uk-select" name="manager_id" v-model="managerId" @change="updateManager">
                    <option :value=0 >-- SELECT REQUESTING MANAGER --</option>
                    <option v-for="val in employees" :value="val.id" >{{val.full_name}}</option>
                </select>
            </div>
            <div class="uk-width-1-3" style="padding-top: 24px;">

            </div>
        </div>
        <div class="uk-grid">
            <div class="uk-width-1-3">
                <label class="uk-form-label">Requesting Manager Phone</label>
                <div class="uk-form-controls">
                    <input type="text" class="uk-input" v-model="managerPhone" disabled />
                </div>
            </div>
            <div class="uk-width-2-3">
                <label class="uk-form-label">Requesting Manager Email</label>
                <div class="uk-form-controls">
                    <input type="text" class="uk-input" v-model="managerEmail" disabled />
                </div>
            </div>
        </div>
        <div class="divider thin uk-margin-medium uk-margin-medium-top"></div>
        <div class="uk-grid">
            <div class="uk-width-2-3">
                <label class="uk-form-label">Second Point of Contact (optional)</label>
                <select class="uk-select" name="contact_id" v-model="contactId" @change="updateContact">
                    <option :value=0 >-- SELECT CONTACT --</option>
                    <option v-for="val in employees" :value="val.id" >{{val.full_name}}</option>
                </select>
            </div>
            <div class="uk-width-1-3" style="padding-top: 24px;">

            </div>
        </div>
        <div class="uk-grid">
            <div class="uk-width-1-3">
                <label class="uk-form-label">Contact Phone</label>
                <div class="uk-form-controls">
                    <input type="text" class="uk-input" v-model="contactPhone" disabled />
                </div>
            </div>
            <div class="uk-width-2-3">
                <label class="uk-form-label">Contact Email</label>
                <div class="uk-form-controls">
                    <input type="text" class="uk-input" v-model="contactEmail" disabled />
                </div>
            </div>
        </div>
		<div class="uk-grid uk-margin-auto-bottom">
			<div class="uk-width-2-3">
				<label class="uk-form-label">Other Responsible Users</label>
				<select class="uk-select" name="other_contact_id" v-model="addUserId" @change="addUser">
					<option :value=0 >-- SELECT USER --</option>
					<option v-for="val in users" :value="val.id" >{{val.full_name}}</option>
				</select>
			</div>
			<div class="uk-width-1-3" style="padding-top: 24px;">
				<input type="hidden" name="user_ids" v-model="additionalUserIds" />
			</div>
		</div>
		<div v-for="user in userList" class="uk-grid uk-margin-remove-top">
			<div class="uk-width-1-3">{{ user.full_name }}</div>
			<div class="uk-width-1-6">{{ user.phone }}</div>
			<div class="uk-width-1-3">{{ user.email }}</div>
			<div class="uk-width-1-6"><i class="fas fa-times" style="cursor: pointer;" @click="dropUser(user.id)"></i></div>
		</div>
    </div>
</template>

<script>
    export default {
        name: "RequisitionManagers",

        props: {
            rid: {type:Number, default:0},
            canEditStatus:{type:Boolean},
			recruiterMgrReqd:{type:Boolean},
            userId:{type:Number, default:0},
            defaultStatus:{type:String, default:"open"}
        },

        data(){
            return {
                reqNumber:"",
                managerId:0,
                managerPhone:"",
                managerEmail:"",
                contactId: 0,
                contactPhone: "",
                contactEmail: "",
                recruiterId: 0,
                recruiterPhone: "",
                recruiterEmail: "",
				addUserId: 0,
				additionalUserIds: [],
                employees:[],
				recruiters:[],
				users:[],
				userList:[],
                status: this.defaultStatus,
                statusName: this.defaultStatus == "open" ? "Open":"New",
                statusOptions:[
                    {
                        value:"new",
                        name:"New"
                    },
					{
                        value:"open",
                        name:"Open"
                    },
					{
                        value:"in progress",
                        name:"In Progress"
                    },
					{
                        value:"fulfilled",
                        name:"Fulfilled"
                    },
                    {
                        value:"completed",
                        name:"Completed"
                    },
                    /*{
                        value:"closed",
                        name:"Closed"
                    }*/
                ]
            };
        },

        mounted(){
           this.loadEmployees();
        },

        methods:{
            loadEmployees(){
                axios.get("/api/users/managers").then((pack) => this.updateEmployeeList(pack));
                axios.get("/api/users/recruiters").then((pack) => this.updateRecruiterList(pack));
                axios.get("/api/users/all").then((pack) => this.updateUsersList(pack));
            },
            updateEmployeeList(pack){
                if(pack.data.success){
                    this.employees = pack.data.data;
                }
                if(this.rid !== 0){
                    this.loadRequisition();
                } else {
                    for(let i = 0; i < this.employees.length; ++i){
                        if(this.employees[i].id == this.userId){
                            this.managerId = this.userId;
                            this.updateManager();
                            break;
                        }
                    }
                }
            },
			updateRecruiterList(pack){
                if(pack.data.success){
                    this.recruiters = pack.data.data;
                }
            },
			updateUsersList(pack){
                if(pack.data.success){
                    this.users = pack.data.data;
					this.buildUserList();
                }
            },
            startSearch(){
                this.loadEmployees();
            },
            loadRequisition(){
                axios.get("/api/requisition/get/" + this.rid)
                    .then((pack) => this.updateRequisitionData(pack));
            },
            updateRequisitionData(pack){
                if(pack.data.success){
                    let data = pack.data.data;
                    this.reqNumber = data.number;
                    this.managerId = data.manager_id > 0 ? data.manager_id:0;
                    this.contactId = data.contact_id > 0 ? data.contact_id:0;
                    this.recruiterId = data.recruiter_id > 0 ? data.recruiter_id:0;
					this.additionalUserIds = data.user_ids;
                    let validStatus = false;
                    for(let i = 0; i < this.statusOptions.length;++i){
                        if(data.status == this.statusOptions[i].value){
                            this.statusName = this.statusOptions[i].name;
                            validStatus = true;
                            break;
                        }
                    }
                    this.status = validStatus ? data.status:"";

                    this.updateManager();
                    this.updateContact();
                    this.updateRecruiter();
					this.buildUserList();
                }
            },
            updateManager(){
                for(let i = 0; i < this.employees.length; ++i){
                    if(this.employees[i].id == this.managerId){
                        this.managerEmail = this.employees[i].email;
                        this.managerPhone = this.employees[i].phone;
                        return;
                    }
                }
				this.managerEmail = "";
				this.managerPhone = "";
            },
            updateContact(){
                for(let i = 0; i < this.employees.length; ++i){
                    if(this.employees[i].id == this.contactId){
                        this.contactEmail = this.employees[i].email;
                        this.contactPhone = this.employees[i].phone;
                        return;
                    }
                }
				this.contactEmail = "";
				this.contactPhone = "";
            },
            updateRecruiter(){
                for(let i = 0; i < this.recruiters.length; ++i){
                    if(this.recruiters[i].id == this.recruiterId){
                        this.recruiterEmail = this.recruiters[i].email;
                        this.recruiterPhone = this.recruiters[i].phone;
                        return;
                    }
                }
				this.recruiterEmail = "";
				this.recruiterPhone = "";
            },
			addUser(){
				if(!isNaN(this.addUserId) && this.addUserId > 0){
					this.additionalUserIds.push(this.addUserId);
					this.addUserId = 0;
					//clear out any duplicates
					this.additionalUserIds = [...new Set(this.additionalUserIds)];
					this.buildUserList();
				}
			},
			dropUser(id){
				for(let i = 0; i < this.additionalUserIds.length;++i){
					if(this.additionalUserIds[i] == id){
						this.additionalUserIds.splice(i, 1);
						break;
					}
				}
				this.buildUserList();
			},
			buildUserList(){
				this.userList = [];
				for(let i = 0; i < this.additionalUserIds.length;++i){
					let uid = this.additionalUserIds[i];
					for(let j = 0; j < this.users.length;++j){
						if(this.users[j].id == uid){
							this.userList.push(this.users[j]);
							break;
						}
					}
				}
			},
            checkNumber(){
                if(this.reqNumber == ""){
                    return;
                }
                if(this.rid !== 0){
                    axios.get("/api/requisition/verify/" + this.reqNumber + "/" + this.rid)
                        .then((pack) => this.alertVerification(pack));
                } else {
                    axios.get("/api/requisition/verify/" + this.reqNumber)
                        .then((pack) => this.alertVerification(pack));
                }
                this.$refs.check_btn.classList.remove("uk-button-danger");
                this.$refs.check_btn.classList.remove("uk-button-success");
                this.$refs.check_btn.querySelector(".fas").classList.remove("fa-check-double");
                this.$refs.check_btn.querySelector(".fas").classList.remove("fa-times");
                this.$refs.check_btn.querySelector(".fas").classList.add("fa-sync-alt");
                this.$refs.check_btn.querySelector(".fas").classList.add("fa-spin");
            },
            alertVerification(pack){
                if(pack.data.success){
                    this.$refs.check_btn.classList.add("uk-button-success");
                    this.$refs.check_btn.querySelector(".fas").classList.add("fa-check-double");
                } else {
                    this.$refs.check_btn.classList.add("uk-button-danger");
                    this.$refs.check_btn.querySelector(".fas").classList.add("fa-times");
                }
                this.$refs.check_btn.querySelector(".fas").classList.remove("fa-sync-alt");
                this.$refs.check_btn.querySelector(".fas").classList.remove("fa-spin");
            }
        }
    }
</script>

<style scoped>

</style>
